import { render, staticRenderFns } from "./messageButton.vue?vue&type=template&id=b9ba7c8e&scoped=true"
import script from "./messageButton.vue?vue&type=script&lang=js"
export * from "./messageButton.vue?vue&type=script&lang=js"
import style0 from "./messageButton.vue?vue&type=style&index=0&id=b9ba7c8e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ba7c8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9ba7c8e')) {
      api.createRecord('b9ba7c8e', component.options)
    } else {
      api.reload('b9ba7c8e', component.options)
    }
    module.hot.accept("./messageButton.vue?vue&type=template&id=b9ba7c8e&scoped=true", function () {
      api.rerender('b9ba7c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messageButton.vue"
export default component.exports